module.exports = __webpack_public_path__ + "img/grey-city.e61ec785.jpg";